<template>
    <div class="all">
        
        <header class="header">
            <!-- <img class="header-title" src="@/assets/index/nftgiveaway/b6d0e4cd23bb32916473de40965e41971df6deea379e8copy2_2x.png" alt=""> -->
            <section class="header-title"></section>
            <section class="time-box">
                <div class="time-item"><div>{{days|twoDigits}}</div></div>
                <div class="time-item"><div>{{hours|twoDigits}}</div></div>:
                <div class="time-item"><div>{{minutes|twoDigits}}</div></div>:
                <div class="time-item"><div>{{seconds|twoDigits}}</div></div>
            </section>
            <img class="join-btn"  @click="openVideo()" src="@/assets/index/nftgiveaway/button2x.png" style="object-fit:contain">
            <section class="icon">
                <div class="dib tar" >
                    <img class="img2" src="@/assets/index/nftgiveaway/binance2x.png">
                    <p style="font-size:20px;line-height:30px">Scan with Binance App</p>
                </div>
                <div class="tar dib" style="margin-left:30px">
                    <div style="padding:6px;border-radius:5px;background:#fff;width:100px;height:100px;box-sizing: border-box;">
                        <img class="img1" src="@/assets/index/nftgiveaway/miniappcode.png" >
                    </div>
                </div>
            </section>
            <section v-if="showVideo" class="video-box"> 
                <div @click="closeVideo()" class="close-btn">X</div>
                <video controls v-if="showVideo" class="video" autoplay>
                    <source src="@/assets/video/xinmc_batch.mp4" type="video/mp4">
                        Sorry, your browser doesn't support embedded videos.
                </video>  
            </section>
            <section class="prize">
                <section class="prize-desc">
                    <img src="@/assets/index/nftgiveaway/rectangle14_2x.png" style="object-fit:contain">
                    <span class="prize-text">{{$t('event_26')}}</span>
                    <img src="@/assets/index/nftgiveaway/rectangle14_2x.png" style="object-fit:contain">
                </section>
                <section>
                    <img class="prize-count" src="@/assets/index/nftgiveaway/amount_2x.png" style="object-fit:contain">
                </section>
            </section>
        </header>
        
        <section class="content">
            <img class="background-img-one" src="@/assets/index/nftgiveaway/layer82_2x.png">
            <img class="background-img-two" src="@/assets/index/nftgiveaway/layer83_2x.png">
            <img class="background-img-three" src="@/assets/index/nftgiveaway/layer84_2x.png">
            <img class="background-img-four" src="@/assets/index/nftgiveaway/layer85_2x.png">
            <section class="total">
                <section class="total-box">
                    <div class="total-item-1">
                        <img class="total-img" src="@/assets/index/nftgiveaway/box_view.9db7b7f0_2x.png" alt="">
                        <div class="total-item">
                            <div class="total-desc">Total Box</div>
                            <div><span class="total-num">5,000</span></div>
                        </div>
                    </div>
                    <div class="total-item">
                        <div class="total-desc">{{$t('event_27')}}</div>
                        <div class="avatar-box">
                            <img src="@/assets/index/nftgiveaway/union51_2x.png" alt="">
                            <span class="total-num">{{total_count}}</span>
                        </div>
                    </div>
                    <div class="total-item">
                        <div class="total-desc">{{$t('event_28')}}</div>
                        <div class="avatar-box">
                            <img src="@/assets/index/nftgiveaway/union51_2x.png" alt="">
                            <span class="total-num">{{total_ticket}}</span>
                        </div>
                    </div>
                </section>
            </section>
            <section class="rules">
                <section class="rule rule-odd">
                    <div class="rule-title">Event Rules 01</div>
                    <div class="rule-desc">{{$t('event_30')}}</div>
                    <div class="rule-img">
                        <img class="rule-img-one" src="@/assets/index/nftgiveaway/Group8662_2x.png">
                    </div>
                </section>
                <section class="rule rule-even">
                    <div class="rule-title">Event Rules 02</div>
                    <div class="rule-desc" v-html="$t('event_31').replace(`#1#`, `<span style='color:#12DAE7'>1 BOX</span>`)"></div>
                    <div class="rule-img">
                        <img class="rule-img-two" src="@/assets/index/nftgiveaway/Group8640_2x.png" alt="">
                    </div>
                </section>
                <section class="rule rule-odd">
                    <div class="rule-title">Event Rules 03</div>
                    <div class="rule-desc" v-html="$t('event_32').replace(`#1#`, `<span style='color:#12DAE7'>5% </span>`)"></div>
                    <div class="rule-img">
                        <img class="rule-img-three" src="@/assets/index/nftgiveaway/group16_2x.png" alt="">
                    </div>
                </section>
                <section class="rule rule-even">
                    <div class="rule-title">Event Rules 04</div>
                    <div class="rule-desc">
                        {{$t('event_33')}}</div>
                    <div class="rule-last-img">
                        <div class="img-item">
                            <img src="@/assets/index/nftgiveaway/group1_2x.png" alt="">
                        </div>
                        <div class="img-item">
                            <img src="@/assets/index/nftgiveaway/group2_2x.png" alt="">
                        </div>
                    </div>
                </section>
            </section>
            <section class="footer">
                <section class="footer-title">MOMOverse Launching on Binance Ecosystem</section>
                <section class="footer-content">
                    <img class="binance-icon" src="@/assets/index/nftgiveaway/binanceicon822x.png">
                    <section class="footer-desc">If you want to access the MOMOverse on the Binance App you need to make sure you have the latest Binance App installed on your device.</section>
                </section>
                <section class="footer-btn-box">
                    <img class="footer-btn" @click="openVideo()" src="@/assets/index/nftgiveaway/button2x.png" style="object-fit:contain">
                    <a href="https://mbox.medium.com/80959e34d892" target="_balnk"><img class="footer-btn" src="@/assets/index/nftgiveaway/learnmore182x.png" style="object-fit:contain"></a>
                </section>
            </section>
            <!-- <img class="top" @click="scrollTop()" src="@/assets/index/nftgiveaway/top17_2x.png"> -->
        </section>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    data(){
        return {
            total_count:'--',
            total_ticket:'--',
            now: Math.trunc(new Date().getTime() / 1000),
            interval: null,
            diff: 0,
            showVideo: false,
            firstDeadLine:1638266400,
            deadline:1638266400
        }
    },
    created(){
        this.interval = setInterval(() => {
            // this.now = Math.trunc(new Date(Date.UTC(Date.now())).getTime() / 1000)+8*3600;
            this.now=Math.trunc(new Date().getTime() / 1000);
            if(this.now-this.firstDeadLine>=0&&this.deadline!==1638835200){
                // this.deadline=Math.trunc(new Date(Date.UTC(2021,11,7,8,0,0)).getTime() / 1000)+8*3600
                this.deadline=1638835200;
            }
        }, 1000);
    },
    watch:{
        now(){
            this.diff=this.deadline-this.now;
            if (this.diff < 0 || this.stop) {
                this.diff=0;
                clearInterval(this.interval);
            }
        }
    },
    mounted(){
        this.getData();
    },
    computed: {
        seconds() {
            return Math.trunc(this.diff) % 60;
        },
        minutes() {
            return Math.trunc(this.diff / 60) % 60;
        },
        hours() {
            return Math.trunc(this.diff / 60 / 60) % 24;
        },
        days() {
            return Math.trunc(this.diff / 60 / 60 / 24);
        },
    },
    filters: {
        twoDigits(value) {
            if (value.toString().length <= 1) {
                return '0' + value.toString();
            }
            return value.toString();
        },
    },
    methods:{
        async getData(){
            const {data}=await request('https://miniappserverapi.mobox.io/user/data/total',{
                method: 'POST',
            });
            this.total_count=this.format_with_regex(data.total_count);
            this.total_ticket=this.format_with_regex(data.total_ticket);
        },
        format_with_regex(number) {
            if(typeof number!=='number'&&typeof number!=='string'){
                return 0;
            }
            var reg = /(\d)(?=(?:\d{3})+$)/g   
            return (number + '').replace(reg, '$1,');
        },
        openVideo(){
            this.showVideo=true;
        },
        closeVideo(){
            this.showVideo=false;
        },
        // 滚动到顶部
        scrollTop() {
            window.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
            });
        }
    },
    destroyed() {
        clearInterval(this.interval);
    },
}
</script>

<style lang="less" scoped>
    .all{
        color: black;
        background-color: black;
    }
    .header{
        color: black;
        position: relative;
        // height:1208px;
        height: 120vh;
        // width: 100vw;
        background-image: url('../../assets/index/nftgiveaway/layer81_2x.png');
        background-repeat:no-repeat;
        background-size: cover;
        background-position: center;
        .header-title{
            position: absolute;
            height: 15vh;
            width: 100vw;
            top: 18.5vh;
            left: 50%;
            transform: translateX(-50%);
            background-image: url('../../assets/index/nftgiveaway/b6d0e4cd23bb32916473de40965e41971df6deea379e8copy2_2x.png');
            background-repeat:no-repeat;
            background-size: contain;
            background-position: center;
            
        }

        .time-box{
            position: absolute;
            top: 41vh;
            left: 50%;
            transform: translateX(-50%);
            font-size: 1.8vw;
            color: white;
            font-family: Poppins;
            font-weight: 800;
            .time-item{
                color: white;
                display: inline-block;
                background-image: url('../../assets/index/nftgiveaway/rectangle13_2x.png');
                background-repeat:no-repeat;
                background-size: contain;
                background-position: center;
                width: 5vw;
                height: 6vw;
                text-align: center;
                line-height:6vw;
                margin-right: 0.3vw;
            }
        }

        .join-btn{
            position: relative;
            cursor: pointer;
            height: 11.5vh;
            width: 21.5vw;
            top: 65vh;
            left: 50%;
            transform: translateX(-50%);
        }

        .icon{
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            top: 67vh;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            color: #fff;
            box-sizing: border-box;
            height: 10vh;
            .img1{
                width: 100%;
                height: 100%;
            }
        }
        .aveage-box > *{
            flex: 1;
        }
        .tal{
            text-align: left;
        }
        .tar{
            text-align: right;
        }
        .dib{
            display: inline-block
        }
        .video-box{
            position: fixed;
            left: 50%;
            right: 50%;
            width: 100vw;
            transform: translate(-50%, -50%);
            z-index: 22;

            // top: 20vh;
            // height: 30vw;
            .video{
                position: absolute;
                width: 50vw;
                left: 50%;
                transform: translateX(-50%);
                z-index: 1;
            }

            .close-btn{
                position: absolute;
                width: 2vw;
                height: 2vw;
                right: 25.5vw;
                font-size: 2vw;
                color: #B5B5B5;
                cursor: pointer;
                line-height: 2vw;
                text-align: center;
                z-index: 999;
            }
        }

        .prize{
            position: absolute;
            bottom: 2.8vh;
            left: 50%;
            transform: translateX(-50%);
            width: 62vw;
            height: 27vh;
            background-image: url('../../assets/index/nftgiveaway/b6d0e4cd23bb32916473de40965e41971df6deea379e86s5iUZ_2x.png');
            background-repeat:no-repeat;
            background-size: contain;
            background-position: center;
            text-align: center;
            .prize-desc{
                margin-top:5.6vh;
                text-align: center;
                font-size: 1.2vw;
                font-family: Poppins;
                font-weight: bold;
                color: #B5B5B5;
                img{
                    width: 1vw;
                    height: 1vw;
                }
                .prize-text{
                    margin: 0 0.4vw;
                }
            }
            .prize-count{
                // text-align: center;
                width: 28.8vw;
                height: 14vh;
            }
        }
    }

    .content{
        position: relative;
        height: 360vh;
        top: -7vh;
        background-color: #000000;
        .background-img-one{
            position: absolute;
            right: 0;
            top:12.3vw;
            width:6vw;
            height: 19.6vw;
        }
        .background-img-two{
            position: absolute;
            left: 0;
            top:26.8vw;
            width: 29.1vw;
            height: 32vw;
        }
        .background-img-three{
            position: absolute;
            right: 0;
            bottom:54vw;
            width: 21.4vw;
            height: 32vw;
        }
        .background-img-four{
            position: absolute;
            left: 0;
            bottom:50vw;
            width: 9vw;
            height: 21vw;
        }
        .total{
            height: 16vh;
            width: 62vw;
            margin: 0 auto;
            margin-top: 6.8vh;
            display: flex;
            .total-box{
                flex: 1;
                display: flex;
                justify-content: space-between;
                .total-item-1{
                    .total-img{
                        width: 9vw;
                        margin-right: 0.8vw;
                        object-fit: contain;
                    }
                    display: flex;
                    text-align: center;
                }
                .total-item{
                    display: flex;
                    text-align: center;
                    flex-direction: column;
                    justify-content: center;
                    img{
                        object-fit: contain;
                        width: 2.1vw;
                        height: 2.1vw;
                    }
                    .total-desc{
                        font-size: 1.2vw;
                        font-family: Poppins;
                        font-weight: bold;
                        color: #B5B5B5;
                        line-height: 1.2vw;
                        margin-bottom: 1vw;
                    }
                    .total-num{
                        font-size: 2.4vw;
                        font-family: Poppins;
                        font-weight: 800;
                        color: #FFFFFF;
                        line-height: 2.4vw;
                        margin-left: 0.6vw;
                    }
                }
            }
        }
        .rules{
            position: absolute;
            margin-top: 24vh;
            left: 50%;
            transform: translateX(-50%);
            .rule-odd{
                // height: 62.5vh;
                background-image: url('../../assets/index/nftgiveaway/layer76_2x.png');
                background-size: cover;
            }
            .rule-even{
                // height: 90vh;
                background-image: url('../../assets/index/nftgiveaway/layer77_2x.png');
                background-size: cover;
            }
            .rule{
                border-radius: 25px;
                width: 62vw;
                margin-bottom: 10vh;
                background-repeat:no-repeat;
                background-size: cover;
                background-position: center;
                .rule-title{
                    color: #FFFFFF;
                    width: 25vw;
                    height: 11vh;
                    text-align: center;
                    position: relative;
                    left: 50%;
                    transform: translate(-50%,-40%);
                    background-image: url('../../assets/index/nftgiveaway/gro16_2x.png');
                    background-repeat:no-repeat;
                    background-size: contain;
                    background-position: center;
                    font-size: 2vw;
                    font-family: Poppins;
                    font-weight: 800;
                    line-height: 8.3vh;
                }
                .rule-desc{
                    color: #FFFFFF;
                    text-align: center;
                    font-size: 1vw;
                    font-family: Poppins;
                    font-weight: 400;
                    margin: 1.4vw auto;
                    width: 36vw;
                }
                .rule-img{
                    text-align: center;
                    .rule-img-one{
                        width:19.5vw;
                        height:14.3vw;
                        object-fit: contain;
                    }
                    .rule-img-two{
                        width:20vw;
                        height:20vw;
                        object-fit: contain;
                    }
                    .rule-img-three{
                        width:13.5vw;
                        height:10vw;
                        object-fit: contain;
                    }
                }
                .rule-last-img{
                    display:flex;
                    justify-content: center;
                    .img-item{
                        // width: 436px;
                        width: 17vw;
                        height: 17vw;
                        background-image: url('../../assets/index/nftgiveaway/MaskGroup_2x.png');
                        background-repeat:no-repeat;
                        background-size: contain;
                        background-position: center;
                        line-height: 17vw;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0 2vw;
                        img{
                            object-fit: contain;
                            width: 12.5vw;
                            height: 12.5vw;
                        }
                    }
                }
            }
        }

        .footer{
            display: flex;
            position: absolute;
            bottom: 10vh;
            width: 100vw;
            height: 30vh;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .footer-title{
                width: 50vw;
                font-size: 2vw;
                font-family: Poppins;
                font-weight: 800;
                color: #FFFFFF;
                line-height: 2vw;
                text-align: center;
            }
            .footer-content{
                width:45vw;
                display: flex;
                justify-content: space-around;
                .binance-icon{
                    width: 4.1vw;
                    height: 4.1vw;
                }
                .footer-desc{
                    flex: 1;
                    font-size: 1vw;
                    font-family: Poppins;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 1vw;
                    padding: 1vw;
                    text-align: center;
                }
            }
            .footer-btn-box{
                width: 42vw;
                display: flex;
                justify-content: space-around;
                .footer-btn{
                    cursor: pointer;
                    height: 10.5vh;
                    width: 20.5vw;
                    margin-right:1vw;
                }
            }
        }

        .top{
            position: absolute;
            bottom: 9vh;
            right: 5vw;
            width: 5.4vw;
            height: 5.4vw;
            object-fit: contain;
        }
    }
    @media (max-width: 768px) {
        .header{
            height: 100vh;
            background-image: url('../../assets/index/nftgiveaway/mobilebg.png');
            .header-title{
                top: 18vh;
                height: 30vh;
                width: 80vw;
                background-image: url('../../assets/index/nftgiveaway/lALPJwKtxCLPSIXNAXDNA38_895_368.png');
                background-repeat:no-repeat;
                background-size: contain;
                background-position: center;
            }
            .time-box{
                top: 46vh;
                width: 100vw;
                font-size: 8vw;
                text-align: center;
                .time-item{
                    color: white;
                    font-size: 8vw;
                    width: 17vw;
                    height: 17vw;
                    line-height: 17vw;
                    div{
                        transform: scale(0.7);
                    }
            }
            }
            .join-btn{
                height: 9vh;
                top: 60vh;
                width: 80vw;
            }
            .icon{
                top: 90vh;
                width: 75vw;
                justify-content: space-around;
                zoom: 0.7;
            }
            .video-box{
                position:fixed;
                top: 30%;
                left: 50%;
                transform: translate(-50%, -50%);

                // top: -10vh;
                // height: 30vw;
                .video{
                    width: 100vw;
                }

                .close-btn{
                    position: absolute;
                    width: 5vw;
                    height: 5vw;
                    right: 0;
                    font-size: 5vw;
                    line-height: 5vw;
                    text-align: center;
                }
        }
            .prize{
                bottom:0;
                height: 6vh;
                width: 100vw;
                background-size: cover;
                height: 15vh;
                .prize-desc{
                    font-size: 6vw;
                    margin-top: 0;
                    transform: scale(0.5);
                    img{
                        width: 4vw;
                        height: 4vw;
                    }
                }
                .prize-count{
                    width: 70vw;
                    height: auto;
                }
            }
        }
        .content{
            top: -3vh;
            // height: 1980px;
            height: 260vh;
            .total{
                width: 95vw;
                margin-top: 1.8vh;
                height: 40vh;
                .total-box{
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-around;
                    .total-item-1{
                        .total-img{
                            width: 24vw;
                            margin-right: 2vw;
                            object-fit: contain;
                        }
                    }
                    .total-item{

                        .total-desc{
                            font-size: 4vw;
                            line-height: 4vw;
                            margin-bottom: 2vw;
                        }
                        img{
                            object-fit: contain;
                            width: 6vw;
                            height: 6vw;
                            margin-right: 2vw;
                        }
                        .total-num{
                            font-size: 8vw;
                            line-height: 8vw;
                        }
                        .avatar-box{
                            text-align: center;
                        }
                    }
                }
            }
        //     .total{
        //         height: 16vh;
        //         width: 62vw;
        //         margin: 0 auto;
        //         margin-top: 6.8vh;
        //         display: flex;
        //     .total-img{
        //         width: 9vw;
        //         margin-right: 0.8vw;
        //         object-fit: contain;
        //     }
        //     .total-box{
        //         flex: 1;
        //         display: flex;
        //         justify-content: space-between;
        //         .total-item{
        //             display: flex;
        //             text-align: center;
        //             flex-direction: column;
        //             justify-content: center;
        //             img{
        //                 object-fit: contain;
        //                 width: 2.1vw;
        //                 height: 2.1vw;
        //             }
        //             .total-desc{
        //                 font-size: 1.2vw;
        //                 font-family: Poppins;
        //                 font-weight: bold;
        //                 color: #B5B5B5;
        //                 line-height: 1.2vw;
        //                 margin-bottom: 1vw;
        //             }
        //             .total-num{
        //                 font-size: 2.4vw;
        //                 font-family: Poppins;
        //                 font-weight: 800;
        //                 color: #FFFFFF;
        //                 line-height: 2.4vw;
        //                 margin-left: 0.6vw;
        //             }
        //         }
        //     }
        // }
            .rules{
                margin-top: 20px;
                .rule{
                    margin-bottom: 7vh;
                    width: 93vw;
                    .rule-title{
                        width: 40vw;
                        height: 7vh;
                        line-height: 6vh;
                        font-size: 4vw;
                        transform: translate(-50%,-30%);
                    }
                    .rule-desc{
                        width: 66vw;
                        font-size: 4vw;
                    }
                    .rule-img{
                        .rule-img-one{
                            width:44.5vw;
                            height:auto;
                            object-fit: contain;
                        }
                        .rule-img-two{
                            width:45.6vw;
                            height:auto;
                            object-fit: contain;
                        }
                        .rule-img-three{
                            width:35.5vw;
                            height:auto;
                            object-fit: contain;
                        }
                    }
                    .rule-last-img{
                        .img-item{
                            width: 38.7vw;
                            height: 38.7vw;
                            img{
                                width: 29vw;
                                height: 29vw;
                            }
                        }
                    }
                }
            }
            .footer{
                background-color: black;
                display: flex;
                position: absolute;
                bottom: -10vh;
                height: auto;
                width: 100vw;
                flex-direction: column;
                justify-content: space-between;
            .footer-title{
                width: 80vw;
                font-size: 5vw;
                font-family: Poppins;
                font-weight: 800;
                color: #FFFFFF;
                text-align: center;
                line-height: 9vw;
            }
            .footer-content{
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-around;
                width: 80vw;
                .binance-icon{
                    width: 10vw;
                    height: 10vw;
                    margin: 2vw;
                }
                .footer-desc{
                    flex: 1;
                    font-size: 3vw;
                    font-family: Poppins;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 5vw;
                    padding: 1vw;
                    text-align: center;
                }
            }
            .footer-btn-box{
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                width: 100vw;
                .footer-btn{
                    cursor: pointer;
                    height: auto;
                    width: 80vw;
                    margin: 2vw;
                }
            }
        }
            .top{
                display: none;
            }
        }
    }
    @media (max-width: 280px) {
        .content{
            height: 1740px;
        }
    }

    @media (max-height: 568px) {
        .content{
            height: 300vh;
        }
    }
    @media (max-height: 668px) {
        .content{
            height: 270vh;
        }
    }
</style>